

















import { defineComponent, ref } from "@nuxtjs/composition-api";
import PBHelper from "~/components/PageBuilder/utils/helper";
import PBComponent from "~/components/PageBuilder/utils/component";
const { loadAsyncComponent } = PBComponent();

export default defineComponent({
  name: "ContentBlock",
  components: {
    ...loadAsyncComponent(),
  },
  props: {
    tag: {
      type: String,
      default: "div",
    },
    node: {
      type: String,
      default: "div",
    },
    attr: {
      type: Object,
      default: () => {},
    },
    children: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    const { getComponentName } = PBHelper();
    const childComponents = ref([]);

    const pb = {children: props.children};
    if (pb.children[0]["child"]) {
      childComponents.value = pb.children[0]["child"];
    }

    return {
      childComponents,
      getComponentName,
    };
  },
});
